import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import PropinsiEn from "../../../utilities/PropinsiEn";
import imgCheckBox from "../../../assets/images/icons/checkbox_blank_outline_icon.png"
import imgCheckBoxIcon from "../../../assets/images/icons/checkbox_icon.png"
import Kemasan from "../../../utilities/Kemasan";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 210,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    pageTwo: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingRow: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 9,
        textAlign: "center",
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 9,
        textAlign: "center",
        marginBottom: 3
    },
    textRefNo: {
        fontSize: 7,
        textAlign: "right"
    },
    texthal2: {
        fontSize: 9,
        textAlign: "right"
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableIdt: {
        borderLeftWidth: 1,
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableIdt2: {
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCol: {
        width: '100%',
        padding: 3,
        textAlign: 'left',
    },
    tableCol1: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableColIdt1: {
        width: '50%',
        padding: 3,
        textAlign: 'left',
    },
    tableColIdt2: {
        width: '50%',
        padding: 3,
        textAlign: 'left',
    },
    text: {
        fontSize: 7,
        textAlign: "center",
        fontWeight: "bold",
    },
    italicText: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "center",
    },
    textEn: {
        fontSize: 8,
        textAlign: "left",
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "left",
    },
    textEn7: {
        fontSize: '4.4',
        textAlign: "left",
    },
    textIn7: {
        fontFamily: "Roboto-Italic",
        fontSize: '4.4',
        textAlign: "left",
    },
    textBox: {
        fontSize: 9
    },
    squareStyle: {
        width: '10px',
        height: '10px',
        border: 1,
        borderColor: '#000000',
    },
    checkicon: {
        width: 12,
        height: 12
    },
    sectionHeader: {
        paddingTop: 0, // tidak ada padding dinamis
        marginBottom: 0
    }
})

const FormXA = ({ dataDisposisi, datappm }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmKemasan, setPpmKemasan] = useState([])
    const [totalJumlah, setTotalJumlah] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuAreaAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resTotal,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuArea
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setTotalJumlah(getData(resTotal));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuArea(getData(resMutuArea))

        } catch (error) {
            console.error("Gagal memuat data:", error);
        }

    }, [datappm, dataDisposisi, transaksiService, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    // useEffect(() => {
    //     if (!datappm) return
    //     const fetchAllData = async () => {
    //         try {
    //             let jsonMutuPK = {
    //                 nomorAju: datappm.nomorAju,
    //                 noProses: dataDisposisi.noTugas
    //             }
    //             const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
    //             setDataHc(resHc.data)

    //             const resUpt = await userService.getUptById(datappm.kdUpt)
    //             // console.log(resUpt)
    //             setUpt(resUpt.data)

    //             const resNeg = await masterService.getNegaraById(datappm.negaraPartner)
    //             setNegaraTujuan(resNeg.data)

    //             const jsonPelMuat = {
    //                 jnsPelabuhan: "D",
    //                 kodePelabuhan: datappm.pelabuhanMuat
    //             }
    //             const resPelDn = await masterService.getPelabuhanById(JSON.stringify(jsonPelMuat))
    //             setPelMuat(resPelDn.data)

    //             const jsonPelLn = {
    //                 jnsPelabuhan: "L",
    //                 kodePelabuhan: datappm.pelabuhanBongkar
    //             }
    //             const resPelLn = await masterService.getPelabuhanById(JSON.stringify(jsonPelLn))
    //             setPelBongkar(resPelLn.data)

    //             const resDetil = await transaksiService.listPpmDetilAll(datappm.nomorAju)
    //             setPpmDetil(resDetil.data.data)

    //             const resTotal = await transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju)
    //             setTotalJumlah(resTotal.data.data)

    //             const resMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
    //             setPpmMutu(resMutu.data)

    //             const resMutuArea = await transaksiService.getPpmMutuAreaById(datappm.nomorAju)
    //             setPpmMutuArea(resMutuArea.data)

    //             const resKemasanAll = await transaksiService.listPpmKemasanAll(datappm.nomorAju)
    //             setPpmKemasan(resKemasanAll.data.data)

    //             const resKontainer = await transaksiService.listPpmContainerAll(datappm.nomorAju)
    //             setPpmKontainer(resKontainer.data.data)
    //         } catch (error) {
    //             // console.log(error)
    //             // setJumlahKemasan(null)
    //             // setUraianKemasan(null)
    //         }
    //     }
    //     fetchAllData()
    // }, [datappm, transaksiService, dataDisposisi, masterService, userService])

    return (
        <Document>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                <View style={styles.sectionHeader} fixed>
                    <View>
                        <Text style={styles.textRefNo}>Veterinary certificate to EU / Sertifikat Kesehatan ke UE</Text>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1, borderTop: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.1. Consignor / </Text>
                                    <Text style={styles.textIn}>Pengirim :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>Name / </Text>
                                    <Text style={[styles.textIn, { paddingLeft: 5 }]}>Nama :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>Address / </Text>
                                    <Text style={styles.textIn}>Alamat :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>Tel No. / </Text>
                                    <Text style={styles.textIn}>No Telp :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.telpPengirim : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderBottom: 0, borderTop: 1, borderRight: 1, paddingLeft: 3 }]}>
                                <View style={[styles.tableRow]}>
                                    <Text style={styles.textEn}>I.2. Certficate Reference / </Text>
                                    <Text style={styles.textIn}>Nomor Sertifikat: </Text>
                                </View>
                                <View style={[styles.tableRow, { borderBottom: 1 }]}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                                </View>
                                <View style={[styles.tableCol, { paddingLeft: 3 }]}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>I.3. Central Competent Authority / </Text>
                                        <Text style={styles.textIn}>Otoritas Kompeten Pusat: </Text>
                                    </View>
                                    <View style={[styles.tableCol, { borderBottom: 1 }]}>
                                        <Text style={styles.textEn}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                                    </View>
                                </View>
                                <View style={[styles.tableCol, { borderBottom: 0, paddingLeft: 3 }]}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>I.4. Local Competent Authority / </Text>
                                        <Text style={styles.textIn}>Otoritas Kompeten Daerah: </Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>{upt !== null ? upt.nmInggris : '-'}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.5. Consignee/</Text>
                                    <Text style={styles.textIn}>Penerima Borang :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>Name / </Text>
                                    <Text style={[styles.textIn, { paddingLeft: 5 }]}>Nama :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>Address / </Text>
                                    <Text style={styles.textIn}>Alamat :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>Postcode / </Text>
                                    <Text style={styles.textIn}>Kode Pos :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.kdposPenerima : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>Tel No. / </Text>
                                    <Text style={styles.textIn}>No Telp :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.telpPneerima : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.6. </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>I.7. Country of Origin / </Text>
                                <Text style={styles.italicText}>Negara Asal</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>ISO-Code/</Text>
                                <Text style={styles.italicText}>Kode ISO</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>I.8. Region of Origin / </Text>
                                <Text style={styles.italicText}>Wilayah Asal</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Code / </Text>
                                <Text style={styles.italicText}>Kode</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>I.9. Country of Destination</Text>
                                <Text style={styles.italicText}>Negara Tujuan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>ISO-Code</Text>
                                <Text style={styles.italicText}>Kode ISO</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>I.10.</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderBottomWidth: 1 }]}>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={styles.text}>INDONESIA</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text]}>ID</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text]}>{upt !== null ? <PropinsiEn id={upt.kdProp} /> : '-'}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text]}>{upt !== null ? upt.kdProp : '-'}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text]}>{negaraTujuan !== null ? negaraTujuan.uraianNegara : '-'}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text]}>{datappm !== null ? datappm.negaraPartner : '-'}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text]}>-</Text>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={[styles.tableRow, { borderRightWidth: 1 }]}>
                            <View style={[styles.tableColIdt1, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.11. Place of Origin / </Text>
                                    <Text style={styles.textIn}>Tempat Asal </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Name / </Text>
                                    <Text style={styles.textIn}>Nama :</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Address / </Text>
                                    <Text style={styles.textIn}>Alamat :</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Approval Number / </Text>
                                    <Text style={styles.textIn}>Nomor Approval</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{ppmMutu !== null ? ppmMutu.upiNoRegUe : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableColIdt]}>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 3 }]}>I.12.</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.13. Place of Loading / </Text>
                                    <Text style={styles.textIn}>Tempat Muat :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelMuat !== null ? pelMuat.uraianPelabuhan : '-'}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.14. Date of departure / </Text>
                                    <Text style={styles.textIn}>Tanggal Berangkat :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.15. Means of transport</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Aeroplane/</Text>
                                        <Text style={styles.textIn}>Pesawat Terbang</Text>
                                        {/* <View style={styles.squareStyle}></View> */}
                                        {
                                            datappm !== null && datappm.moda === '3' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Ship/</Text>
                                        <Text style={styles.textIn}>Kapal Laut</Text>
                                        {
                                            datappm !== null && datappm.moda === '1' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Railway Wagon/</Text>
                                        <Text style={styles.textIn}>Kereta Api Barang</Text>
                                        <Image src={imgCheckBox} style={styles.checkicon} />
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Road Vehicle/</Text>
                                        <Text style={styles.textIn}>Angkutan Umum</Text>
                                        <Image src={imgCheckBox} style={styles.checkicon} />
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Other/</Text>
                                        <Text style={styles.textIn}>Lainnya</Text>
                                        <Image src={imgCheckBox} style={styles.checkicon} />
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Identification / </Text>
                                    <Text style={styles.textIn}>Identifikasi</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nmTrans : ''} / {dataHc !== null ? dataHc.noFlight : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Documentation References / </Text>
                                    <Text style={styles.textIn}>Referensi dokumen</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={[styles.tableCol, { borderBottom: 0, borderTop: 0, borderRight: 0, paddingLeft: 3 }]}>
                                    <Text style={styles.textEn}>I.16. Entry BIP in EU / </Text>
                                    <Text style={[styles.textIn, { paddingLeft: 5 }]}>Pelabuhan Tujuan di UE </Text>
                                </View>
                                <View style={[styles.tableRow, { borderBottom: 1 }]}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}</Text>
                                </View>
                                <View style={[styles.tableCol, { paddingLeft: 3 }]}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>I.17.</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.18. Description of commodity</Text>
                                    <Text style={styles.textIn}>Deskripsi Produk</Text>
                                </View>
                                <View style={[styles.tableRow]}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{ppmMutu !== null ? ppmMutu.mutuDesk : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={[styles.tableCol, { borderBottom: 0, borderTop: 0, borderRight: 0, paddingLeft: 3 }]}>
                                    <Text style={styles.textEn}>I.19. Comodity Code (HS-Code)/ </Text>
                                    <Text style={[styles.textIn, { paddingLeft: 5 }]}>Kode HS Produk</Text>
                                </View>
                                <View style={[styles.tableRow, { borderBottom: 1 }]}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>
                                        {
                                            ppmDetil.map((detil, index) => {
                                                return <>{detil.kodeHs}</>
                                            })
                                        }
                                    </Text>                                </View>
                                <View style={[styles.tableCol, { paddingLeft: 3 }]}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>I.20. Quantity/</Text>
                                        <Text style={[styles.textIn, { paddingLeft: 5 }]}>Jumlah</Text>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>
                                            {
                                                totalJumlah.map((detil, index) => {
                                                    return (
                                                        detil.kodeSatuan.toUpperCase() === 'KGM' ?
                                                            detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() :
                                                            detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() + ' = ' + detil.totalNetto + ' KGM'
                                                    )
                                                })
                                            }
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.21. Temperature of product / </Text>
                                    <Text style={styles.textIn}>Temperatur produk</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Ambient / </Text>
                                        <Text style={styles.textIn}>Ruang</Text>
                                        {
                                            ppmMutu !== null && ppmMutu.mutuTempTipe === '1' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Frozen / </Text>
                                        <Text style={styles.textIn}>Beku</Text>
                                        {
                                            ppmMutu !== null && ppmMutu.mutuTempTipe === '3' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Chilled / </Text>
                                        <Text style={styles.textIn}>Dingin</Text>
                                        {
                                            ppmMutu !== null && ppmMutu.mutuTempTipe === '2' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                    </View>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.22. Number of packages / </Text>
                                    <Text style={styles.textIn}>Jumlah Kemasan :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>
                                        {
                                            ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                                return (
                                                    <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />;</>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.23. Seal/ Container No / </Text>
                                    <Text style={styles.textIn}>No. Segel / Kontainer</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmKontainer !== undefined && ppmKontainer !== null &&
                                            ppmKontainer.map((kont, index) => {
                                                return (
                                                    <>
                                                        {kont.nomor} / {kont.nomorSegel} ;
                                                    </>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.24. Type of packaging / </Text>
                                    <Text style={styles.textIn}>Jenis Kemasan</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>
                                        {
                                            ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                                return (
                                                    <><Kemasan id={kms.kodeKemasan} />;</>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.25. Commodities certified for/ </Text>
                                    <Text style={styles.textIn}>Komoditas yang disertifikasi untuk: </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Human consumption / </Text>
                                    <Text style={styles.textIn}>Konsumsi manusia </Text>
                                    {
                                        datappm !== null && datappm.peruntukan === '1' ?
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.26.</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.27. For import or admission into EU / </Text>
                                </View>
                                <View style={[styles.tableRow, { paddingLeft: 5 }]}>
                                    <Text style={styles.textIn}>Untuk impor atau ijin masuk ke UE </Text>
                                    {
                                        ppmMutu !== null && ppmMutu.upiNoRegUe !== null ?
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableIdt, { borderBottom: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1, borderBottom: 0 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>I.25. Identification of the commodities / </Text>
                                    <Text style={styles.textIn}>Identifikasi komoditas</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableIdt, { borderBottom: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0 }]}>
                                <Text style={styles.text}>Species (Scientific name) / </Text>
                                <Text style={styles.italicText}>Spesies (nama latin)</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                                <Text style={styles.text}>Nature of Commodity /</Text>
                                <Text style={styles.italicText}>Asal produk</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                                <Text style={styles.text}>Treatment type / </Text>
                                <Text style={styles.italicText}>Jenis perlakuan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 0 }]}>
                                <Text style={styles.text}>Approval number of establishments Manufacturing Plant/ </Text>
                                <Text style={styles.italicText}>Nomor Approval Pabrik Pengolahan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0 }]}>
                                <Text style={styles.text}>Number of packages</Text>
                                <Text style={styles.italicText}>Jumlah Kemasan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Net weight</Text>
                                <Text style={styles.italicText}>Berat bersih</Text>
                            </View>
                        </View>
                    </View>
                    {
                        ppmDetil.map((detil, index) => {
                            return (
                                <>
                                    <View key={index} style={[styles.tableRow, { borderBottomWidth: 1, borderTop: 0 }]}>
                                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0, borderLeftWidth: 1 }]}>
                                            <Text style={[styles.text]}>{detil.namaLatin}</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                                            <Text style={[styles.text]}>
                                                {
                                                    ppmMutuArea !== null && ppmMutuArea !== undefined && ppmMutuArea.mutuArea === '1' ?
                                                        'Farm' : 'Wild'
                                                }
                                            </Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 0 }]}>
                                            <Text style={[styles.text]}> - </Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 0 }]}>
                                            <Text style={[styles.text]}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                            <Text style={[styles.text]}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 0 }]}>
                                            <Text style={[styles.text]}>
                                                {
                                                    ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                                        return (
                                                            <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />;</>
                                                        )
                                                    })
                                                }
                                            </Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                            <Text style={[styles.text]}>{detil.jumlah} {detil.kodeSatuan}</Text>
                                        </View>
                                    </View>
                                </>
                            )
                        })
                    }
                </View>
            </Page>
            <Page size="LEGAL" style={styles.pageTwo} wrap={false}>
                <View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={[styles.texthal2, { textAlign: "left" }]}>COUNTRY/NEGARA : INDONESIA</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={[styles.texthal2, { textAlign: "right" }]}>Fishery Products/ Produk perikanan</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableIdt, { borderTop: 1 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "50%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: "left" }]}>II. Health Information/</Text>
                            <Text style={[styles.italicText, { paddingLeft: 13, textAlign: "left" }]}>Informasi Kesehatan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "31%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: "left" }]}>II.a. Certificate reference number / </Text>
                            <Text style={[styles.italicText, { paddingLeft: 13, textAlign: "left" }]}>Nomor Sertifikat</Text>
                            <View style={[styles.tableRow, { borderBottom: 0 }]}>
                                <Text style={[styles.text, { paddingLeft: 13, textAlign: "left" }]}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { textAlign: "left" }]}>II.b. </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableIdt, { borderRightWidth: 1 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableRow, { width: "3%" }]}>
                            <Text style={styles.textEn7}>II.1.</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.textEn7}>(1) Public health Attestation</Text>
                            <Text style={styles.textIn7}>(1) Pernyataan kesehatan umum</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { paddingLeft: 10 }]}>
                            <Text style={styles.textEn7}>the undersigned, declare that I am aware of the relevant provisions of regulation (EC) No 178/2002. (EC) No. 852/2004, (EC) No. 853/2004 and (EC) No 854/2004 and certify that the fishery products deser above were produced in accordance with those requirements, in particular that they: </Text>
                            <Text style={styles.textIn7}>Saya yang bertanda tangan di bawah ini menyatakan bahwa saya menyadari sepenuhnya keterkaitan dari ketetapan peraturan peraturan (KE) No. 178/2002. (KE) No. 852/2004, (KE) No. 853/2004 dan (KE) No.854/2004 dan menyatakan dengan sebenarnya bahwa produk perikanan yang dijelaskan di atas diproduksi sesuai dengan peraturan-peraturan tersebut, khususnya bahwa produk tersebut:</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>come from (an) establishment(s) implementing a programme based on the HACCP principles in accordance with Regulation (EC) No. 852/2004,/</Text>
                            <Text style={styles.textIn7}>/berasal dari unit pengolahan ikan yang menerapkan program berdasarkan prinsip-prinsip HACCP sexuai dengan Peraturan (KE) No. 852/2004, </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>have been caught and handled on board vessels, landed, handled and where appropriate prepared, processed, frozen and thawed hygienically in compliance with the requirements laid down in section VIII, Chapter 1 to IV of Annex 111 to Regulation (EC) No 853/2004,</Text>
                            <Text style={styles.textIn7}>/telah ditangkap dan ditangani di atas kapal perikanan, didaratkan, ditangani dan dipersiapkan, diolah, dibekukan dan dilelehkan secara higienis sesuai dengan persyaratan pada sekti VIII Rab I sampai dengan IV Lampiran III Peraturan (KE) No.853/2004, </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>satisfy the health standards laid down in section Vill, Chapter V of Annex III to Regulation (EC) No 853/2004 and the criteria laid down in regulation (EC) No 2073/2005 on microbiological criteria for foodstuffs,</Text>
                            <Text style={styles.textIn7}>/ Lampiran III Peraturan (KE) No 853/2004 dan kriteria yang tertulis dalam Peraturan (KE) No 2073/2005 tentang kriteria mikrobiologikal untuk bahan pangan, </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>have been packaged, stored and transported in compliance with Section VIII, Chapters Vito VIII of Annex III to Regulation (EC) No. 853/2004,</Text>
                            <Text style={styles.textIn7}>/telah dikemas, disimpan dan diangkut sesuai dengan Seksi VIII. Bab 17, Bab VII dan VIII Lampiran Peraturan (KE) No. 853/2004 </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>have been marked in accordance with section 1 of Annes II to Regulation (EC) No 853/2004,</Text>
                            <Text style={styles.textIn7}>/telah ditandai sesuai dengan seksi I Lampiran II peraturan (KE) No.854/2004,  </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>the guarantees covering live animals and products thereof, if from aquacultore orfgin, provided by the residue plans submitted in accordance with Directive 96/23/EC, and in particular: Article 29 thereof, are fulfilled, and</Text>
                            <Text style={styles.textIn7}>jaminan ini mencakup hewan dan produk hidup, jika berasal asli dari pembudidayaan, harus dilengkapi dengan rencana monitoring residu sesuai dengan Direktif 96/23/EC, dan khususnya Pasal 29, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>have satisfactorily undergone the official controls laid down in Annex III to Regulation (EC) No 854/2004/</Text>
                            <Text style={styles.textIn7}>telah dilakukan pengendalian dengan memuaskan sebagaimana Lampiran III Peraturan (KE) No. 854/2004</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>II.2. (2)(4)Animal health attestation for fish and crustaceans of aquaculture origin</Text>
                            <Text style={[styles.textIn7, { paddingLeft: 12 }]}>(2)(4) Pernyataan kesehatan hewan untuk ikan dan krustasea yang dibudidayakan</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>II.2.1. (3)(4)[Requirements for susceptible species to Epizootic haematopoietic necrosis (EIN), Taura syndrome and Yellowhead disease. /</Text>
                            <Text style={[styles.textIn7, { paddingLeft: 14 }]}>(3)(4)Persyaratan untuk jenis-jenis yang rentan terhadap penyakit Epizootic haematopoletic necrosis (EHN), Taura syndrome dan yellowhead.</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 14 }]}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>I, undersigned official inspector, hereby certify that the aquaculture animals or products thereof referred to in Part Lof this certificate: (5)originate from a country/territory, zone or compartiment declared free from (4)[EHN] (4) Taura syndrome) (4)(Yellow head disease) in accordance with Chapter VII of Directive 2006/88/EC or the relevant OTE Standard by the competent authority of my country, </Text>
                            <Text style={styles.textIn7}>Saya, inspektur mutu yang bertanda tangan dibawah ini, menyatakan bahwa produk budidaya sebagaimana disebutkan pada Bagian I sertifikat ini berasal dari negara/territorial, zona atau kompartemen yang telah dinyatakan bebas dari (4)EHN, (4) Taura syndrome (4) Yellowhead sesuai dengan Bab VII Directive 2006/88/EC ataw Standard OIE yang sesuai oleh Otoritas Kompeten di Indonesia,</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>i) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>where the relevant diseases are notifiable to the competent authority and reports of suspicion of infection of the relevant disease must be immediately investigated by the competent authority,</Text>
                            <Text style={styles.textIn7}>Apabila penyakit-penyakit tersebut tendeteksi oleh Otoritas Kompeten dan adanya laporan tentang kecurigaan infeksi oleh penyakit yang relevan harus segera diinvestigasi oleh otoritas kompeten</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>ii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>all introduction of species susceptible to the relevant diseases come from an area declared free of the disease, and</Text>
                            <Text style={styles.textIn7}>Seluruh pengenalan jenis yang rentan terhadap penyakit-penyakit tersebut diatas berasal darı area yang telah dinyatakan bebas dari penyakit, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>iii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>species susceptible to the relevant diseases are not vaccinated against the relevant diseases.</Text>
                            <Text style={styles.textIn7}>jenis yang rentan terhadap penyakit-penyakit tersebut diatas tidak divaksinasi dengan vaksin penyakit-penyakit tersebut. </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.2. </Text>
                                <Text style={[styles.textEn7, { width: '97%' }]}>(3)(4)[Requirements for species susceptible to Viral haemorrhagic septicaemia (VHS), Infectious haematopoietic necrosis (IHN), Infectious salmon anaemia (ISA), Koi herpes virus (KHV) and White spot disease Intended for a Member State, zone or compartment declared disease free or subject to a surveillance or eradication programme for the relevant disease.</Text>
                            </View>
                            <Text style={[styles.textIn7, { paddingLeft: 16 }]}>(3)(4) Persyaratan untuk jenis-jenis yang rentan terhadap penyakit Viral haemorrhagic septicaemia (VHS), Infectious haematopoletic necrosis (IHN), Infectious salmon anaemia (ISA), Koi herves virus (KHV), dan bintik putih (white spot) untuk tujuan ekspor ke negara anggota UE, zona atau kompartemen yang telah dinyatakan bebas penyakit atau telah disurvailen atau telah melalui program pemberantasan penyakit-penyakit yang relevan.</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 14 }]}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>1, the undersigned official inspector, hereby certify that the aquaculture animals or products thereof referred to in Part I of this certificate: (*)onginate from a country territory, zone or compartment declared free from (4) [VHS] (+)[HN] (4)[ISA](4)[KHV] (4) [White spot disease) in accordance with Chapter VII of Directive 2006/88/EC or the relevan OIE Standard by the competent authority of my country,</Text>
                            <Text style={styles.textIn7}>Saya Inspektur mutu yang bertanda tangan dibawah ini menyatakan bahwa hewan/produk budidaya sebagaimana disebutkan pada bagian I sertifikat ini, ()Berasal dari negara territorial, zona atau kompartemen yang telah dinyatakan bebas dari penyakit (VHS (4)IHN, (4)ISA, (4)KHV (bintik putih (white spot) sesuai dengan Bab VII Directive 2006/88/EC atau Standard OIE yang sesuai oleh Otoritas Kompeten di Indonesia</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>i) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>where the relevant diseases are notifiable to the competent authority and reports of suspicion of Infection of the relevant disease must be immediately investigated by the competent authority,</Text>
                            <Text style={styles.textIn7}>Apabila penyakit-penyakit tersebut tendeteksi oleh Otoritas Kompeten dan adanya laporan tentang kecurigaan infeksi oleh penyakit yang relevan harus segera diinvestigasi oleh otoritas kompeten</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>ii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>all introduction of species susceptible to the relevant diseases come from an area declared free of the disease, and/</Text>
                            <Text style={styles.textIn7}>seluruh pengenalan jenis yang rentan terhadap penyakit-penyakit tersebut diatas berasal dari area yang telah dinyatakan bebas dari penyakit, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>iii) </Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>species susceptible to the relevant diseases are not vaccinated against the relevant diseases] </Text>
                            <Text style={styles.textIn7}>jenis yang rentan terhadap penyakit-penyakit tersebut diatas tidak divaksinasi dengan vaksin penyakit-penyakit tersebut. </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>II.2.3. Transport and labelling requirements </Text>
                            <Text style={[styles.textIn7, { paddingLeft: 14 }]}>Persyaratan Transportasi dan pelabelan </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 14 }]}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textEn7}>I, the undersigned official inspector, hereby certify that/</Text>
                            <Text style={styles.textIn7}>Saya, inspektur mutu dibawah ini menyatakan bahwa</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.3.1</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { paddingLeft: 13 }]}>
                            <Text style={styles.textEn7}>the aquaculture animals referred to above are placed under conditions, including with a water quality, that do not alter their health status; /</Text>
                            <Text style={styles.textIn7}>hewan budidaya sebagaimana tersebut diatas ditempatkan pada kondisi, termasuk mutu air, yang tidak mempengaruhi status kesehatannya </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.3.2</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { paddingLeft: 13 }]}>
                            <Text style={styles.textEn7}>the transport container or well boat prior to loading is clean and disinfected or previously unused, and</Text>
                            <Text style={styles.textIn7}>/ wadah transportasi atau palka pada perahu sebelum dimasukkan dalam keadaan bersih dan disveihamakan atau sebelumnya tidak digunakan, dan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>II.2.3.3</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { paddingLeft: 13 }]}>
                            <Text style={styles.textEn7}>the consignment is identified by a legible label on the exterior of the container, or when transported by well boat, in the ship's manifest, with the relevant information referred to in boxes 1.7 to 1.11 of Part 1 of this certificate, and the following statement</Text>
                            <Text style={styles.textIn7}>/partai produk vang dikirim diidentifikasi dengan label yang dapat dibaca pada bagian luar wadah, atau pada saat transportasi dengan perahu, pada manifestasi kapal, dengan informasi yang relevan sesuai dalam kotak no 17 sampai 1.11 pada sertifikat ini dan pernyataan berikut </Text>
                        </View>
                    </View>
                    <View style={styles.tableCol}>
                        <View style={[styles.tableRow, { paddingLeft: 27 }]}>
                            <Text style={styles.textEn7}>"(4)[Fish](4)|Crustaceans] Intended for human consumption In the Union"./ </Text>
                            <Text style={styles.textIn7}>"(4) Ikan dan (4) Krustasea untuk tujuan konsumsi manusia di Negara Uni Eropa</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 3 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>Notes</Text>
                                <Text style={styles.textIn7}>/Catatan</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>Part I</Text>
                                <Text style={styles.textIn7}>/Bagian I</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Box Reference I.8</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 10 }]}>:</Text>
                                <Text style={styles.textEn7}>Region of origin, For frozen and processed bivalve molluses, indicate the production area.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.8 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={styles.textEn7}>Wilayah asal. Untuk kekerangan beku atau vang diolah, disebutkan daerah produksinya.</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Box Reference I.11</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 10 }]}>:</Text>
                                <Text style={styles.textEn7}>Place of origin name and address of the dispatch establishment/</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.11 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={styles.textEn7}>Tempat Asal : Nama dan alamat UPI.</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Box Reference I.15</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 10 }]}>: </Text>
                                <Text style={styles.textEn7}>Registration number (railway waigon or container and lorries), flight number (aircraft) or name (ship). Separate information is to be provided in the event of unloading and reloading/</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.15 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={styles.textEn7}>Nomor registrasi (kereta barang atau kontainer dan lori), nomor penerbangan (pesawat) atau nama (kapal). Dibuat keterangan yang terpisah pada saat pembongkaran dan pemuatan kembali</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Box Reference I.19 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 10 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '95%' }]}>Use the appropriate Harmonized System (HS) codes of the World Custom Organization of the following headings: 03.01, 03.02, 03.03, 03.04, 03.05, 03.06, 03.07, 03.08, 05.11, 15.04, 15.16, 15.18, 16.03, 16.04, 16.05 atau 21.06 </Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.19 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '95%' }]}>Menggunakan Kode Harmonized System (HS)" yang sesuai dengan Organizası Bea Cukai Dunia untuk judul-judul sebagai berikut: 03.01, 03.02, 03.03, 03.04, 03.05, 03.06, 03.07, 03.08, 05.11, 15.04, 15.16, 15.18, 16.03, 16.04, 16.05 atau 21.06</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Box Reference I.23</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 10 }]}>:</Text>
                                <Text style={styles.textEn7}>Identification of container/seal number where there is a serial number of the seal it has to be indicated/</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.23</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 2 }]}>:</Text>
                                <Text style={styles.textEn7}>Kontainer No Segel apabila terdapat no seri segel, maka harus dicantumkan </Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 10 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Box Reference I.28 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 10 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '80%' }]}>Nature of commodity: specify wether aquaculture or wild origin. Treatment type: specify whether live, chilled, frozen or processed. Manufacturing plant: includes factory vessel freezer vessel, cold store, processing plant.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>- Kotak Referensi I.28 </Text>
                                <Text style={[styles.textEn7, { paddingLeft: 5 }]}>: </Text>
                                <Text style={[styles.textEn7, { width: '80%' }]}>Asal produk jelaskan apakah hasil budidaya atau hasil tangkap Jenis perlakuan hidup, didinginkan, dibekukan atau diolah. Pabrik pengolahan meliputi kapal pengolah, kapal pembeku, gudang penyimpanan beku dan pabrik pengolahan </Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { paddingLeft: 3 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>Part II</Text>
                                <Text style={styles.textIn7}>/Bagian II</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableCol, { paddingLeft: 5 }]}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(1)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Part II.1 of this certificate does not apply to countries with special public health certification requirements laid down in equivalence agreements or other Union legislation.</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 8 }]}>Bagian II.1 dari sertifikat ini tidak berlaku bagi negara-negara dengan persyaratan sertifikasi kesehatan publik khusus seperti tertuang dalam perjanjian ekivalensi atau legislasi UE lainnya.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(2)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Part II.2 of this certificate does not apply to/</Text>
                                <Text style={[styles.textIn7]}>Bagian II.2 dari sertifikat ini tidak berlaku bagi:</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>a)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>non-viable crustaceans, which means crustaceans no longer able to survive as living animals if returned to the environment from which they were obtained,</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>krustasea yang tidak dapat hidup lagi apabila dikembalikan ke lingkungan dimana mereka hidup.</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>b)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>fish which are slaughtered and eviscerated before dispatch,</Text>
                                <Text style={[styles.textIn7]}>/ Ikan yang disembelih dan disiangi sebelum diberangkatkan</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>c)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>aquaculture animals and products thereof, which are placed on the market for human consumption without further processing, provided that they are packed in retail-sale packages which comply with the provisions for such packages in Regulation (EC) No 853/2004,/</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>Hewan budidaya dan produknya yang dipasarkan untuk konsumsi manusia tanpa proses pengolahan lebih lanjut, yang dikemas dalam kemasan eceran yang sesuai dengan persyaratan pengemasan yang tercantum pada Regulasi (EC) No. 853/2004</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>d)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>crustaceans destined for processing establishments authorised in accordance with Article 4(2) of Directive 2006/88/EC, or for dispatch centres, purification centres or similar businesses which are equipped with an effluent treatment system inactivating the pathogens in question, or where the effluent is subject to other types of treatment reducing the risk of transmitting diseases to the natural waters to an acceptable level,</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>Krustasea yang ditujukan untuk unit pengolahan ikan yang diotorisasi sesuai dengan pasal 4(2) dara Directive 2006/88/EC, atau sentra pengiriman, sentra purifikasi atau usaha sejenis yang dilengkapi dengan sistem perlakuan effluent untuk menonaktifkan bakteri pathogen yang dicurigai, atau dimana effluent diberi perlakuan lain untuk mereduksi risiko penularan penyakit ke perairan sampai batas yang dapat diterima.</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8 }]}>
                                <Text style={styles.textEn7}>e)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>crustaceans which are intended for further processing before human consumption without temporary storage at the place of processing and packed and labelled for that purpose in accordance with Regulation (EC) No 853/2004/</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 10 }]}>Krustasea yang ditujukan untuk proses pengolahan lanjutan sebelum dikonsumsi manusia tanpa melalui penyimpanan sementara di tempat proses dan dikemas dan diberi label untuk tujuan tersebut sesuai dengan Regulasi (EC) No 853/2004</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(3)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Parts 11.2.1 and 11.2.2 of this certificate only apply to species susceptible to one or more of the diseases referred to in the heading of the point concerned Susceptible species are listed in Annex IV Directive 2006/88/EC/</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 4 }]}>Bagian II.2.1 dan 11.2.2 dari sertifikat ini hanya berlaku bagi jenis-jenis rentan terhadap satu atau lebih penyakit sesuai dengan judul dari butir yang sesuai. Jenis-jenis yang rentan terhadap penyakit tercantum pada Annex IV dari Directive 2006/88/EC</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(4)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>Keep as appropriate/</Text>
                                <Text style={[styles.textIn7]}>Disimpan bila sesuai.</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(5)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>For consignmems of species susceptible to EHN, Taurs syndrome and or Yellow head disease this staterient must be kept for the consignment to be authorised Into any part of the Union.</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 4 }]}>Untuk partai yang dikirim jenis-jenis yang rentan terhadap penyakit EHN. Taura syndrome, dan/atau Yellowhead, pernyataan ini harus disimpan untuk partai/lot yang akan dikirim ke setiap bagian dari UE</Text>
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn7}>(6)</Text>
                                <Text style={[styles.textEn7, { paddingLeft: 3 }]}>To be authorised into a Member State, zone or compartment (boxes 19 and 1.11) of Part 1 of the certificate) declared free from VHS, IHN, ISA, KHV or Whitespot disease or with a surveillance or eradication programme drawn up in accordance with Article 4441) or (2) of Directive 2006/88/FC, one of these statements must be kept if the consignment contain species susceptible to the disease(s) for which disease freedom or programme (s) apply (ies). Data disease status of each farm and molluses farming area in the Union are accessible at http://ec.europa.eu/food/animal/liveanimals/aquaculture/index_en.htm/</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.textIn7, { paddingLeft: 4 }]}>Untuk dapat diotorisasi ke negara anggota UE, zona atau kompartemen (kotak no 1.9 dan 1.10 Bagian I sertifikat) yang telah dinyatakan bebas dari VHS, IHN, ISA, KHV, atau bintik putih (white spot) atau dengan program survailen atau melalui program pemberantasan yang ditetapkan sesuai dengan pasal 44(1) atau (2) dari Directive 2006/88/EC Data tentang status penyakit untuk setiap pembudidayaan dan area buchdaya moluska di UE dapat diakses pada http://ec.europa.eu/food/animal/liveanimals/aquaculture/index_en.htm</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableIdt, { borderTop: 1, borderLeft: 0, borderBottom: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "50%", border: 0 }]}>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Official inspector/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Inspektur Mutu</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Name (in capitals)/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Nama (dengan huruf besar):</Text>
                                    <Text style={[styles.text, { textAlign: "left" }]}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Date/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Tanggal : </Text>
                                    <Text style={[styles.text, { textAlign: "left" }]}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Stamp/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Stempel :</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: "50%", border: 0, paddingTop: 20 }]}>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Qualification and title/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Titel dan Jabatan:</Text>
                                    <Text style={[styles.text, { textAlign: "left" }]}>OFFICIAL INSPECTOR</Text>
                                </View>
                                <View style={[styles.tableCol, { borderBottom: 0 }]}>
                                    <Text style={[styles.text, { textAlign: "left" }]}>Signature/</Text>
                                    <Text style={[styles.italicText, { textAlign: "left" }]}>Tanda tangan</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default FormXA